export default __webpack_public_path__ + "static/media/noArtifact-placeholder.3651812c.png";